"use client";

import type { Footer as FooterType } from "@/payload-types";
import { NewsletterSignupRenderer } from "@/payload/blocks/newsletter-signup/newsletter-signup.renderer";

interface FooterNewsletterSignupProps {
  footer: FooterType;
}

export function FooterNewsletterSignup({ footer }: FooterNewsletterSignupProps) {
  if (!footer.showNewsletterSignup) return null;

  // Map footer fields to block props
  const blockProps = {
    heading: footer.newsletterHeading || "Join our Newsletter",
    description: footer.newsletterDescription || undefined,
    inputPlaceholder: "Enter your email",
    buttonText: "Subscribe",
    backgroundColour: footer.backgroundColour || "black",
    blockType: "newsletter-signup" as const,
    id: "footer-newsletter",
  };

  return <NewsletterSignupRenderer {...blockProps} />;
}
